import React from 'react';
import './HomePageBanner.scss';
import bannerImage from '../../assets/images/homePageBanner.svg';
import { IonCard, IonCardHeader, isPlatform } from '@ionic/react';
import IHomeBanner, { imgActionOptions, imgActionOptionsValues } from '../../interfaces/IHomeBanner';
import { useHistory } from 'react-router';

  interface IHomePageBannerProps {
        info: IHomeBanner
  }

  const HomePageBanner: React.FC<IHomePageBannerProps> = (props) => {
    const history = useHistory();

    const onClick = (actionType?: imgActionOptionsValues, actionURL?: string) => {
      switch (actionType) {
        case imgActionOptions.internalUrl:
          if(actionURL){
            history.push(actionURL, {direction: 'forward'});
          }
          break;
        case imgActionOptions.externalUrl:
          if(actionURL){
            window.open(actionURL);
          }
          break;
        default:
          break;
      }
    }

    return (
        <IonCard mode="md" className="home-page-banner-image">
            <IonCardHeader className={props.info.imgAction ? 'cursor-pointer' : ''}>
                {props.info.imgUrl ?
                      <img alt={props.info.imgAlt ? props.info.imgAlt : "Welcome to Bible Study Together App"} 
                      src={isPlatform('mobile') && props.info.imgUrlMobile ? props.info.imgUrlMobile : props.info.imgUrl} 
                      onClick={()=>{onClick(props.info.imgAction, props.info.imgActionUrl)}}></img>
                      :
                      <img alt="Welcome to Bible Study Together App" src={bannerImage}></img>
                }
            </IonCardHeader>
        </IonCard>
    );
  };
  
  export default HomePageBanner;